import React from "react";
import BlockedCell from "components/Tribe/Friends/BlockedCell";
import ProjectPagination from "components/General/ProjectPagination";
import { paginate } from "utils/paginate";
import "./BlockedListContainer.css";
//ref implementation of frontend/gui/src/components/Project/Home/ProjectGrid.js

class BlockedListContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blockedPageSize: 6,
            blockedCurrentPage: 1,
        };
    }

    handleBlockedPageChange = (page) => {
        this.setState({ blockedCurrentPage: page});
    };

    renderLists(props) {
            if (props.type === "Blocked Users") {
            const blockedListPaginated = paginate(
                props.blockedLists,
                this.state.blockedCurrentPage,
                this.state.blockedPageSize
            );

            const blockedCells = blockedListPaginated.map((elem, index) => (
                <BlockedCell
                    key={elem.id}
                    friendSlug={elem.blocked_user.username}
                    userName={elem.blocked_user.username}
                    blockID={elem.id}
                    profilePic={elem.blocked_user.profile_pic}
                    buttonTitle={props.buttonTitle}
                    datePrefix={props.datePrefix}
                    date={elem.created_at}
                />
            ));
            return (
                <div>
                    <div className="blocked_cell_container">{blockedCells}</div>
                    {props.blockedLists.length <= this.state.blockedPageSize ? (
                        <div></div>
                    ) : (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "30px",
                            }}
                        >
                            <ProjectPagination
                                itemsCount={props.blockedLists.length}
                                pageSize={this.state.blockedPageSize}
                                currentPage={this.state.blockedCurrentPage}
                                onPageChange={this.handleBlockedPageChange}
                            />
                        </div>
                    )}
                </div>
            );
        }
    }

    render() {
        return <div>{this.renderLists(this.props)}</div>;
    }
}

export default BlockedListContainer;
